let catalog = null;

export function setNonReactiveProductCatalog(data) {
	catalog = Object.freeze(data);
}

export function getNonReactiveProductCatalog() {
	return catalog;
}